import React, { useEffect, useState } from 'react';
import axios from 'axios';

const SuperadminFeedbackRate = () => {
  const [data, setData] = useState({ submitted: 0, expected: 0, rate: '0.00' });

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/superadmin/feedback-rate`, { withCredentials: true })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error('❌ Fehler beim Laden der Feedback-Beteiligung:', err);
      });
  }, []);

  return (
    <div className="rounded-2xl shadow-md p-4 bg-[#1a1f2e] text-white">
      <h2 className="text-lg font-semibold mb-2">Feedback-Beteiligung</h2>
      <div className="text-xl font-bold">{data.submitted} / {data.expected}</div>
      <div className="text-sm text-gray-400">Beteiligungsquote: {data.rate} %</div>
    </div>
  );
};

export default SuperadminFeedbackRate;
